
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import PageLayout from "@/components/PageLayout";
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <PageLayout 
      title={t('notFound.title')} 
      showBackButton={false}
      colorScheme="bg-gradient-to-r from-gray-600 to-gray-800"
    >
      <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-4">
        <h1 className="text-5xl sm:text-6xl font-bold mb-4">404</h1>
        <p className="text-lg sm:text-xl text-gray-600 mb-6">{t('notFound.message')}</p>
        <Button 
          onClick={() => navigate("/")}
          className="px-6 py-2"
        >
          {t('common.back')}
        </Button>
      </div>
    </PageLayout>
  );
};

export default NotFound;
